const BASE_URL = 'https://baback-public-logo.s3.eu-west-3.amazonaws.com/external/';


export const getSocialIconPngUrl = (icon: string, color: 'black' | 'white' = 'black') => {
  return `${BASE_URL}${icon}-${color}.png`;
}

/**
 * Glyph-only social icons (transparent background, monochrome silhouette) used
 * by the styled social-networks block (circle/square shape + theme-colored
 * background). Distinct from `getSocialIconPngUrl`, which returns the legacy
 * baked badges (opaque black/white shape). Assets live under a separate
 * `-glyph-` name so the legacy badges stay untouched.
 */
export const getSocialIconGlyphUrl = (icon: string, color: 'black' | 'white' = 'black') => {
  return `${BASE_URL}${icon}-glyph-${color}.png`;
}
